import type { RegisteredRouter } from '@tanstack/react-router';

type RegisteredNavigator = Pick<RegisteredRouter, 'navigate'> & {
  state: { location: { pathname: string } };
};

/**
 * The app router, reachable without importing `@/router`: that module pulls
 * in the whole route tree, and the API client sits under every query hook.
 */
let registeredRouter: RegisteredNavigator | null = null;

export function registerRouter(router: RegisteredNavigator): void {
  registeredRouter = router;
}

export function getRegisteredRouter(): RegisteredNavigator | null {
  return registeredRouter;
}
